module.exports = __webpack_public_path__ + "img/game_gsport.e39ab38.webp";